import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 10V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "4", cy: "16", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m10 10-4.5 4.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m9 11 1 1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileKey2";
const FileKey2 = memo(themed(Icon));
export {
  FileKey2
};
//# sourceMappingURL=file-key-2.js.map
